// components/misc/ModalConfirm.js
import React from "react";

const ModalConfirm = ({ 
  isOpen, 
  onCancel, 
  onClose, // Alias for onCancel
  onConfirm, 
  children, 
  message, // Direct message shortcut
  title, 
  confirmText = "Yes",
  cancelText = "No",
  confirmColor = "bg-red-600",
  customHeight 
}) => {
  if (!isOpen) return null;

  const handleCancel = onCancel || onClose;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-black/60 backdrop-blur-sm transition-all duration-300">
      <div className={`relative w-full max-w-sm mx-auto my-6 px-4`}>
        {/* Modal Content */}
        <div className={`relative flex flex-col w-full ${customHeight || 'h-auto'} bg-white rounded-2xl shadow-xl outline-none focus:outline-none border-2 border-blue-500 overflow-hidden`}>
          {/* Modal Header */}
          <div className="flex items-start justify-between p-4 border-b border-solid rounded-t border-slate-100 bg-gray-50/50">
            <h3 className="text-lg font-bold text-slate-800 uppercase tracking-wide">
              {title}
            </h3>
          </div>
          {/* Modal Body */}
          <div className="relative flex-auto p-5 overflow-y-auto max-h-[70vh]">
            {message && <div className="text-center text-slate-600 font-medium mb-2">{message}</div>}
            {children}
          </div>
          {/* Modal Footer */}
          <div className="flex items-center space-x-3 justify-end px-5 py-4 bg-gray-50/50 border-t border-solid border-slate-100">
            <button
              className="px-5 py-2 rounded-full border border-gray-300 text-sm font-bold text-gray-600 hover:bg-gray-100 transition-all duration-200 active:scale-95"
              type="button"
              onClick={handleCancel}
            >
              {cancelText}
            </button>
            <button
              className={`px-5 py-2 rounded-full ${confirmColor} text-sm font-bold text-white hover:opacity-90 shadow-md transition-all duration-200 active:scale-95`}
              type="button"
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;
